/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : ANALYTICS DETAIL : STYLES --------------- ++++++++++ */
export default theme => ({
	detail: {
        background: '#FDFDFE',
        // hide all filters on load
        '& .name-filters': {
			'& .dropdown': {
				display: 'none'
			}
		},
		// display specific filter based on selected button
		'& .filter': {
			'&-SITE': {
				'& .name-sites': { display: 'block !important' },
                '& .name-site': { display: 'block !important' }
			},
			'&-DEVICE': {
				'& .name-devices': { display: 'block !important' },
                '& .name-device': { display: 'block !important' }
			},
			'&-GEO': {
				'& .name-countries': { display: 'block !important' },
                '& .name-country': { display: 'block !important' }
			},
			'&-EMBED': {
				'& .name-embeds': { display: 'block !important' },
                '& .name-embed': { display: 'block !important' }
			},
			'&-AD_UNIT':{
				'& .name-sites': { display: 'block !important' },
                '& .name-site': { display: 'block !important' }
			},
			'&-AD_TYPE':{
                '& .name-sites': { display: 'block !important' },
                '& .name-site': { display: 'block !important' }
			},
			'&-STORY':{
                '& .name-stories': { display: 'block !important' },
                '& .name-story': { display: 'block !important' }
			}
		},
		// ********** page sections ********** //
		'& section': {
			position: 'relative',
			marginBottom: pxToEm(30),
			// remove margin from last section
			'&:last-child': {
				marginBottom: '0'
			},
			// +++++ detail header +++++ //
			'&.name-detailheader': {
				zIndex: '3',
				'& .gridset': {
					position: 'relative',
					justifyContent: 'space-between',
					// --- title --- //
					'&.name-detailtitle': {
						zIndex: '2',
						opacity: '0',
						animationName: 'fadeInRight',
		                animationDuration: '.2s',
		                animationFillMode: 'forwards',
		                animationDelay: '.1s',

						// alignContent: 'flex-end',
						// alignItems: 'flex-end',
						marginBottom: pxToEm(20),
						'& .title *': {
							marginBottom: '0'
						},
						'& .filter': {
							'&:nth-child(1)': { zIndex: '13' }
						}
					},
					// --- filters --- //
					'&.name-detailfilters': {
						zIndex: '1',
						opacity: '0',
						animationName: 'fadeInLeft',
		                animationDuration: '.2s',
		                animationFillMode: 'forwards',
		                animationDelay: '.1s',

						// alignItems: 'center',
						'& .name-filters': {
							position: 'relative',
							zIndex: '2',
							marginBottom: pxToEm(20)
						},
						'& .name-controls': {
							position: 'relative',
							zIndex: '1',
							marginBottom: pxToEm(20),
							flexWrap: 'wrap',
							'& .control': {
								flex: '1'
							}
						}
					}
				}
			},
			// +++++ detail chart +++++ //
			'&.name-detailchart': {
				marginBottom: pxToEm(60),
				zIndex: '2',
				opacity: '0',
				animationName: 'fadeInUp',
                animationDuration: '.2s',
                animationFillMode: 'forwards',
                animationDelay: '.4s',
				'& .chart': {
					'& .data': {
						'& .visualization': {
							height: pxToEm(400),
							'& .state.nodata': {
								height: pxToEm(330)
							}
						}
					}
				}
			},
			// +++++ detail table +++++ //
			'&.name-detailtable': {
				minHeight: pxToEm(550),
				zIndex: '1',
				opacity: '0',
				animationName: 'fadeInUp',
                animationDuration: '.2s',
                animationFillMode: 'forwards',
                animationDelay: '.5s',
                '& .state.nodata': {
                	height: pxToEm(500)
                },
				'& .exportexcel':{
					fontWeight: "500"
				}
			}
		},
        // hide all filters on load
            // detail header
            '& .name-tabledetailheader': {
                zIndex: '2',
                '& .gridset': {
                    justifyContent: 'space-between',
                    '&.name-tabledetailtitle': {
                        opacity: '0',
                        animationName: 'fadeInRight',
                        animationDuration: '.2s',
                        animationFillMode: 'forwards',
                        animationDelay: '.1s',

                        // alignContent: 'flex-end',
                        // alignItems: 'flex-end',
                        marginBottom: pxToEm(20),
                        '& .title *': {
                            marginBottom: '0'
                        }
                    }
                }
            },
            // table data
            '& .name-tabledetailtable': {
                zIndex: '1',
                opacity: '0',
                animationName: 'fadeInUp',
                animationDuration: '.2s',
                animationFillMode: 'forwards',
                animationDelay: '.3s',
                '& .link': {
                    transitionProperty: 'filter', //removed all transitions except filter due to resizing on click
                    '&.processing-true':{
                        // fontSize: pxToEm(12),
                        '& .text':{
                            display: 'none'
                        },
                        '& .loader': {
                            fontSize: '28%'
                        }
                    }
                },
                '& .state.nodata': {
                    height: pxToEm(500)
                }
            }

	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.thinnest]: { 
		detail: {
			'& .gridset.direction-horizontal': {
				flexDirection: 'column',
				'& .griditem': {
					'& .filter': {
						maxWidth: '100%'
					}
				}
			},
                tabledetail: {
                    '& .gridset.direction-horizontal': {
                        flexDirection: 'column',
                        '& .griditem': {
                            '& .filter': {
                                maxWidth: '100%'
                            }
                        }
                    }
                }
		}
	}
});
